import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFriends } from '../redux/appSlice';
import Friend from './Friend';


const FriendsWidget = ({userId,isProfile}) => {
    const {token} = useSelector((state) => state.app);
    const {friends} = useSelector((state) => state.app.user);
    const dispatch=useDispatch()
    const getFriends = async () => {
        const response = await fetch(`https://thoughtful-erin-oyster.cyclic.app/users/${userId}/friends`,
          {
            method: "GET",
            headers: { authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        dispatch(setFriends({ friends: data }));
      };
    
      useEffect(() => {
        getFriends();
      }, [userId])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='w-full flex flex-col  p-4 bg-white dark:bg-gray-900 rounded-md gap-2 sticky top-8 xs:static'>
        <div className='flex justify-between'>
            <h3 className='text-xs font-semibold text-gray-600 dark:text-gray-200'>Freind List</h3>
        </div>
        {friends?.map((friend)=>(
            <Friend
                key={friend._id}
                friendId={friend._id}
                name={`${friend.firstName} ${friend.lastName}`}
                subTitle={friend.occupation}
                userPicturePath={friend.picturePath}
                isProfile
            />
        ))}
        
    </div>
  )
}

export default FriendsWidget